<template>
  <b-container>
    <b-row>
      <b-col
        cols="12"
      >
        <div class="section-card">
          <div>
            <b-form-checkbox
              v-model="authorityToLeave"
              name="authority_to_leave"
              :value="true"
              :unchecked-value="false"
            >
              Authority to Leave
            </b-form-checkbox>
          </div>
          <div class="description">
            {{ description }}
          </div>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

export default {
  name: 'authority-to-leave',
  computed: {
    authorityToLeave: {
      set: function(value) {
        this.$store.commit('somnambulistui/SET_AUTHORITY_TO_LEAVE', value)
      },
      get: function() {
        return this.$store.getters['somnambulistui/authorityToLeave']
      }
    },
    defaultMessage: function() {
      try {
        return this.$store.getters['ecommerce/getConfigItem']('authority_to_leave', 'default') || 'Authority to leave the package in a safe place if you are not home.'
      }
      catch (err) {
        return 'Authority to leave the package in a safe place if you are not home.'
      }
    },
    enabledMessage: function() {
      try {
        return this.$store.getters['ecommerce/getConfigItem']('authority_to_leave', 'enabled_msg') || null
      }
      catch (err) {
        return null
      }
    },
    disabledMessage: function() {
      try {
        return this.$store.getters['ecommerce/getConfigItem']('authority_to_leave', 'disabled_msg') || null
      }
      catch (err) {
        return null
      }
    },
    description: function() {
      if (this.authorityToLeave && this.enabledMessage) {
        return this.enabledMessage
      }
      else if (!this.authorityToLeave && this.disabledMessage) {
        return this.disabledMessage
      }
      else {
        return this.defaultMessage
      }
    }
  }
}
</script>

<style lang="scss">
// Override custom checkbox styling to restore normal browser appearance
// Using unscoped styles with higher specificity to override global styles
.section-card {
  // Style the description to align with checkbox label text
  .description {
    // Align description with the checkbox label text by adding left margin
    // This accounts for the checkbox box width + spacing
    margin-left: 1.75rem; // Bootstrap's default spacing for custom-control-label
    margin-top: 0.25rem; // Small top margin for visual separation
  }

  // Target Bootstrap Vue checkbox with higher specificity
  .custom-checkbox .custom-control-label::before,
  .form-check .custom-control-label::before,
  .b-form-checkbox .custom-control-label::before {
    // Reset to default browser checkbox appearance
    background-color: white !important;
    border: 2px solid #6c757d !important;
    border-radius: 3px !important;
    width: 1rem !important;
    height: 1rem !important;
  }

  .custom-checkbox .custom-control-input:checked ~ .custom-control-label::before,
  .form-check .custom-control-input:checked ~ .custom-control-label::before,
  .b-form-checkbox .custom-control-input:checked ~ .custom-control-label::before {
    // Reset checked state to browser default
    background-color: #007bff !important;
    border-color: #007bff !important;
  }

  .custom-checkbox .custom-control-input:checked ~ .custom-control-label::after,
  .form-check .custom-control-input:checked ~ .custom-control-label::after,
  .b-form-checkbox .custom-control-input:checked ~ .custom-control-label::after {
    // Ensure checkmark is visible with proper positioning
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='m6.564.75-3.59 3.612-1.538-1.55L0 4.26 2.974 7.25 8 2.193z'/%3e%3c/svg%3e") !important;
    background-size: 0.75rem !important;
    background-position: center !important;
    background-repeat: no-repeat !important;
  }

  .custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before,
  .form-check .custom-control-input:disabled:checked ~ .custom-control-label::before,
  .b-form-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {
    background-color: #6c757d !important;
    border-color: #6c757d !important;
  }

  // Focus state
  .custom-checkbox .custom-control-input:focus ~ .custom-control-label::before,
  .form-check .custom-control-input:focus ~ .custom-control-label::before,
  .b-form-checkbox .custom-control-input:focus ~ .custom-control-label::before {
    border-color: #80bdff !important;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25) !important;
  }

  // Additional fallback - override the CSS variables directly for this component
  .custom-checkbox {
    --main-checkbox-background-color: white !important;
    --main-checkbox-checked-background-color: #007bff !important;
    --main-checkbox-disabled-background-color: #6c757d !important;
  }
}
</style>
